<template>
    <table class="mt-table work-history-table table-to-cards-768" v-if="boardsByCompany.length > 0">
        <thead>
            <th class="toggle"></th>
            <th data-label="Company">Company</th>
            <th data-label="Ticker">Ticker</th>
            <th data-label="Position">Position</th>
            <th data-label="Dates">Dates</th>
            <th data-label="Alpha">Alpha</th>
        </thead>
        <tbody v-for="group in boardsByCompany" :key="group.id">
            <tr>
                <ExpandableRowColumn :active="group.boards.length > 1" :expanded.sync="expanded" :value="group" />
                <td data-label="Company">
                    <CompanyAvatar :company="group.company" />
                    <CompanyLink :company="group.company" />
                </td>
                <td data-label="Ticker">
                    <CompanyLink :company="group.company" symbol />
                </td>
                <td data-label="Position">
                    {{ group.role }}
                </td>
                <td data-label="Dates">
                    <FuzzyDateRange :item="group" />
                </td>
                <td data-label="Alpha">
                    {{ formatAlpha(group.boardAlpha) }}
                </td>
            </tr>
            <template v-if="expanded.has(group)">
                <tr v-for="(board, index) in group.boards" :key="`${group.id}-${index}`">
                    <td colspan="3"></td>
                    <td data-label="position" :title="board.role">
                        {{ board.role }}
                    </td>
                    <td data-label="Dates">
                        <FuzzyDateRange :item="board" />
                    </td>
                    <td data-label="Alpha"></td>
                </tr>
            </template>
        </tbody>
    </table>
    <div class="empty-block" v-else>
        <p class="material-icons company-icon">people</p>
        <h4>No Board Membership</h4>
        <p>Board Membership for this executive will appear here!</p>
    </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import { formatNegativeParens } from '@/utils/format'
import { workHistory } from '@/utils/sorts'

import CompanyAvatar from '@/components/companies/avatar.vue'
import CompanyLink from '@/components/companies/CompanyLink'
import ExpandableRowColumn from '@/components/shared/mt-table/ExpandableRowColumn.vue'
import FuzzyDateRange from '@/components/executives/FuzzyDateRange.vue'

const props = defineProps({
    boards: {
        type: Array,
        required: true,
    },
})

const boardsByCompany = computed(() => {
    if (!props.boards) {
        return []
    }

    let data = {}

    for (let board of props.boards) {
        let company = board.company
        let id = company.id
        let target = data[id]

        if (!target) {
            data[id] = target = {
                id,
                company,
                boards: [],
            }
        }

        target.boards.push(board)
    }

    data = Object.values(data)

    data.forEach(row => {
        row.boards.sort(workHistory.comparer)

        // summarize the board information so we can sort
        // the overall list properly, too
        row.current = row.boards[0].current
        row.role = row.boards[0].role
        row.startDate = row.boards[row.boards.length - 1].startDate
        row.endDate = row.boards[0].endDate
        row.boardAlpha = row.boards[0].boardAlpha
    })

    data.sort(workHistory.comparer)

    return data
})

function formatAlpha(alpha) {
    if (alpha === null) {
        return ''
    }

    return formatNegativeParens(alpha, { style: 'percent', maximumFractionDigits: 1 })
}

const expanded = ref(new Set())
</script>
<style scoped>
table {
    table-layout: fixed;
}

td {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.toggle {
    border-right: none;
    width: 40px;
}

[data-label='Company'] {
    padding-left: 0;
    width: 50%;
}
[data-label='Ticker'] {
    width: 88px;
    padding: 0;
    white-space: nowrap;
    text-align: center;
}
[data-label='Role'] {
    width: 50%;
}
[data-label='Dates'] {
    width: 176px;
    white-space: normal;
}
[data-label='Alpha'] {
    overflow: visible;
    width: 88px;
}

@media (max-width: 960px) {
    .toggle {
        display: none;
    }

    [data-label='Company'] {
        .avatar {
            display: none;
        }
    }
    [data-label='Ticker'] {
        text-align: left;
    }
}
</style>
